import { type ReactNode } from "react"

interface FeatureCardProps {
  /** Icon rendered inside a blue-tinted circle */
  icon: ReactNode
  /** Feature title */
  title: string
  /** Feature description (1-2 sentences) */
  description: string
  /** Additional classes on the wrapper */
  className?: string
}

export function FeatureCard({ icon, title, description, className = "" }: FeatureCardProps) {
  return (
    <div className={`bg-gray-50 rounded-lg p-6 ${className}`}>
      <div className="w-10 h-10 rounded-lg bg-[#0469f0]/10 flex items-center justify-center mb-3">
        {icon}
      </div>
      <h3 className="text-sm font-bold text-gray-900 mb-1">{title}</h3>
      <p className="text-sm text-gray-500 leading-relaxed line-clamp-2">{description}</p>
    </div>
  )
}
